<div class="language-container">
  <div class="header-container" (click)="toggle()">
    <div class="language-header">
      <img *ngIf="languageIcon" [src]="languageIcon" class="language-icon" />
      <div class="h5-medium">{{ language.name }}</div>
      <div class="h5" *ngIf="checked">(Default)</div>
    </div>
    <img [src]="iconsService.Icon.up_1" class="arrow-icon" [ngClass]="hide ? 'down' : 'up'" />
  </div>
  <ng-container *ngIf="!hide">
    <div class="divider"></div>
    <div class="default-container">
      <div class="h5">Set as default language</div>
      <ag-toggle-switch [initValue]="checked" [disableMargin]="true" [showIcons]="false" (toggleCheck)="setAsDefault($event)"></ag-toggle-switch>
    </div>
    <div class="divider" *ngIf="!checked"></div>
    <div class="delete-container" *ngIf="!checked" (click)="deleteLanguage()">
      <img [src]="iconsService.Icon.trash_can_red" class="trash-icon" />
      <div class="h5-semibold delete-button">Delete language</div>
    </div>
  </ng-container>
</div>
